import { IModel, Model, ModelRecord } from '@common/models';
import { defaultTo } from 'lodash';

export interface IClinicCancellationReasonModel extends IModel {
  clinicCancellationReasonId: number;
  name: string;
  sortOrder: number;
  isManuallyAssignable: boolean;
}

export class ClinicCancellationReasonModel
  extends Model
  implements ModelRecord<IClinicCancellationReasonModel>
{
  clinicCancellationReasonId: number;
  name: string;
  sortOrder: number;
  isManuallyAssignable: boolean;

  constructor(params?: Partial<IClinicCancellationReasonModel>) {
    super(params);
    this.clinicCancellationReasonId = defaultTo(
      params?.clinicCancellationReasonId,
      0,
    );
    this.name = defaultTo(params?.name, '');
    this.sortOrder = defaultTo(params?.sortOrder, 0);
    this.isManuallyAssignable = defaultTo(params?.isManuallyAssignable, false);
  }
}
